import React, { Suspense } from "react";
import ErrorBoundry from "./components/commonComponents/ErrorBoundary";
import { useRoutes } from "react-router-dom";
import { publicRoutes } from "./routes/routes";
// Slick Slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-datepicker/dist/react-datepicker.css";
import "./assets/sass/style.scss";
import { useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { clearCacheData } from "./util/Utils";
import {
  externalOktaAuth,
  isExternalAuthenticated,
} from "./util/externalAuth";


function App() {
  const routing = useRoutes(publicRoutes);
  const { authState, oktaAuth } = useOktaAuth();

  const PUBLIC_PATHS = [
    "/",
    "/signup",
    "/external-login",
    "/callback",
    "/forgot-password",
    "/activate-account",
    "/reset-password",
    "/token-expired",
  ];

  useEffect(() => {
    if (
      authState &&
      !authState.isAuthenticated &&
      !isExternalAuthenticated() &&
      !PUBLIC_PATHS.includes(window.location.pathname)
    ) {
      clearCacheData();
      oktaAuth.signOut("/");
    }
  });

  // on okta session expire
  useEffect(() => {
    if (isExternalAuthenticated()) {
      const tokenManager = externalOktaAuth.tokenManager;
      const tokenExpHandler = () => {
        clearCacheData();
        externalOktaAuth.signOut({
          postLogoutRedirectUri: window.location.origin + "/",
        });
      };

      tokenManager.on("expired", tokenExpHandler);
      return () => tokenManager.off("expired", tokenExpHandler);
    }

    if (authState && authState.isAuthenticated) {
      const tokenManager = oktaAuth.tokenManager;

      const tokenExpHandler = () => {
        clearCacheData();
        oktaAuth.signOut("/");
      };

      tokenManager.on("expired", tokenExpHandler);

      return () => {
        tokenManager.off("expired", tokenExpHandler); // Clean up the event handler
      };
    }
  }, [authState, oktaAuth]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <ErrorBoundry>
      <Suspense
        fallback={
          <p style={{ left: "35%", padding: 200, position: "relative" }}>Loading...</p>
        }
      >
        {routing ? routing : <p style={{ left: "35%", padding: 200, position: "relative" }}>Loading...</p>}
      </Suspense>
    </ErrorBoundry>
  );
}

export default App;
